// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation DeleteShipmentMutation($input: DeleteShipmentInput!) {
    deleteShipment(input: $input) {
      deletedId
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_DELETE',
          parentID: ROOT_ID,
          connectionKeys: [{ key: 'PaginatedShipmentsContainer_shipments' }],
          pathToConnection: [ROOT_ID, 'shipments'],
          deletedIDFieldName: 'deletedId',
        },
      ],
    });
  },
};
